module.exports = __webpack_public_path__ + "assets1775130923925/img/logo.2cd77f02.png";